import React, { useState } from 'react';
import { 
  FaStar, 
  FaClock, 
  FaUsers, 
  FaMapMarkerAlt, 
  FaBed, 
  FaUtensils, 
  FaCar, 
  FaPrayingHands,
  FaPhone,
  FaWhatsapp,
  FaEnvelope,
  FaUser,
  FaCalendar,
  FaPaperPlane,
  FaArrowLeft,
  FaTimes,
  FaCheck,
  FaSun,
  FaWater,
  FaMountain,
  FaShoppingBag
} from 'react-icons/fa';
import { GiTempleDoor, GiBoatHorizon, GiIndiaGate, GiElephant, GiPrayerBeads } from 'react-icons/gi';
import { MdDirectionsBoat, MdLocalAirport, MdTrain, MdDirectionsCar } from 'react-icons/md';
import '../style.css';

const TourPackagesSection= () => {
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    date: '',
    message: ''
  });

  const packages = [
    {
      id: 1,
      title: "Kashi Prayag Ayodhya",
      subtitle: "Trinity Pilgrimage",
      duration: "4N/5D",
      discount: "24% OFF",
      rating: 4.9,
      reviews: 156,
      image: "https://www.tripplannersindia.com/assets/images/page/Kashi.webp",
      badge: "Most Popular",
      badgeColor: "#FF6B6B",
      color: "#8B4513",
      icon: <GiPrayerBeads />,
      itinerary: "Varanasi • Prayagraj • Ayodhya",
      details: {
        title: "4 Nights / 5 Days – Varanasi • Prayagraj • Ayodhya Tour Package",
        description: "A spiritually enriching journey covering Kashi (Varanasi), Triveni Sangam (Prayagraj) and Shri Ram Janmabhoomi (Ayodhya) with comfortable stays, private transfers and planned temple darshan.",
        nightPlan: [
          { night: "Night 1", place: "Varanasi" },
          { night: "Night 2", place: "Varanasi" },
          { night: "Night 3", place: "Prayagraj" },
          { night: "Night 4", place: "Ayodhya" }
        ],
        days: [
          {
            day: "Day 1",
            title: "Arrival in Varanasi & Evening Ganga Aarti",
            icon: <FaPrayingHands />,
            activities: [
              "Arrival at Varanasi Airport / Railway Station",
              "Meet & greet and transfer to hotel",
              "Hotel check-in and freshen up",
              "Evening visit to Dashashwamedh / Assi Ghat",
              "Witness the divine Ganga Aarti",
              "Return to hotel – Overnight stay in Varanasi"
            ]
          },
          {
            day: "Day 2",
            title: "Varanasi Temple Tour & Local Sightseeing",
            icon: <GiTempleDoor />,
            activities: [
              "Early morning sunrise boat ride on River Ganga",
              "Return to hotel for breakfast",
              "Kashi temple & city tour (as per time):",
              "  – Shri Kashi Vishwanath Temple",
              "  – Annapurna / Vishalakshi Temple",
              "  – Sankat Mochan, Durga Kund, Tulsi Manas Temple",
              "  – BHU campus & nearby points (optional)",
              "Evening free for local markets & Banarasi saree shopping",
              "Overnight stay in Varanasi"
            ]
          },
          {
            day: "Day 3",
            title: "Varanasi ➝ Prayagraj (Triveni Sangam)",
            icon: <MdDirectionsCar />,
            activities: [
              "Breakfast at hotel & check-out",
              "Drive to Prayagraj (approx. 3–4 hours)",
              "Visit Triveni Sangam – holy snan / boat ride (optional)",
              "Visit Bade Hanuman Temple / Alopi Devi Temple (as per time)",
              "Hotel check-in at Prayagraj",
              "Evening free for local visit / rest",
              "Overnight stay in Prayagraj"
            ]
          },
          {
            day: "Day 4",
            title: "Prayagraj ➝ Ayodhya (Ram Janmabhoomi Darshan)",
            icon: <GiIndiaGate />,
            activities: [
              "Breakfast at hotel & check-out",
              "Drive to Ayodhya",
              "On arrival, visit main temples:",
              "  – Shri Ram Janmabhoomi",
              "  – Hanuman Garhi & other important temples (as per time)",
              "Evening aarti / darshan in Ayodhya",
              "Hotel check-in – Overnight stay in Ayodhya"
            ]
          },
          {
            day: "Day 5",
            title: "Ayodhya ➝ Varanasi / Onward Departure",
            icon: <MdTrain />,
            activities: [
              "Breakfast at hotel",
              "Free time for darshan / local shopping (as per schedule)",
              "Drive back to Varanasi or nearest onward station (as per package plan)",
              "Drop at Airport / Railway Station for onward journey",
              "Tour ends with blessings of Shri Ram & Baba Vishwanath"
            ]
          }
        ],
        inclusions: [
          { icon: <FaBed />, text: "2 Nights hotel stay in Varanasi" },
          { icon: <FaBed />, text: "1 Night hotel stay in Prayagraj" },
          { icon: <FaBed />, text: "1 Night hotel stay in Ayodhya" },
          { icon: <FaUtensils />, text: "Daily breakfast at hotel" },
          { icon: <FaCar />, text: "AC vehicle for all transfers & sightseeing" },
          { icon: <MdLocalAirport />, text: "Pickup & drop as per itinerary" },
          { icon: <FaCar />, text: "Driver allowance, toll, parking, fuel & all taxes" }
        ],
        exclusions: [
          "Flight / Train tickets",
          "Lunch & dinner",
          "Boat ride charges (if not included in final quote)",
          "VIP / special darshan tickets & puja charges",
          "Guide charges, personal expenses, tips",
          "Anything not mentioned in 'Inclusions'"
        ],
        contact: {
          phone: "94157 99879",
          whatsapp: "9415799879",
          company: "Shree Balaji Travel"
        }
      }
    },
    {
      id: 2,
      title: "Char Dham Yatra",
      subtitle: "Himalayan Pilgrimage",
      duration: "10N/11D",
      discount: "23% OFF",
      rating: 4.9,
      reviews: 203,
      image: "https://images.indianexpress.com/2023/05/char-dham-1200.jpg",
      badge: "Holy Journey",
      badgeColor: "#4ECDC4",
      color: "#2D93AD",
      icon: <FaMountain />,
      itinerary: "Yamunotri • Gangotri • Kedarnath • Badrinath",
      details: {
        title: "10 Nights / 11 Days – Char Dham Yatra",
        description: "Complete pilgrimage to the four sacred shrines in the Himalayas – Yamunotri, Gangotri, Kedarnath, and Badrinath.",
        nightPlan: [
          { night: "Night 1-2", place: "Haridwar" },
          { night: "Night 3", place: "Barkot" },
          { night: "Night 4", place: "Uttarkashi" },
          { night: "Night 5-6", place: "Guptkashi" },
          { night: "Night 7-8", place: "Badrinath" },
          { night: "Night 9-10", place: "Rudraprayag" }
        ],
        days: [
          {
            day: "Day 1",
            title: "Arrival Haridwar",
            activities: ["Arrival", "Evening Ganga Aarti", "Hotel Check-in"]
          }
        ],
        inclusions: [
          { icon: <FaBed />, text: "10 Nights Hotel Stay" },
          { icon: <FaUtensils />, text: "All Meals" },
          { icon: <FaCar />, text: "AC Vehicle" },
          { icon: <FaUsers />, text: "Tour Guide" }
        ],
        exclusions: ["Helicopter Tickets", "Personal Expenses", "Travel Insurance"],
        contact: {
          phone: "94157 99879",
          whatsapp: "9415799879",
          company: "Shree Balaji Travel"
        }
      }
    },
    {
      id: 3,
      title: "Golden Temple Tour",
      subtitle: "Sikh Pilgrimage",
      duration: "2N/3D",
      discount: "25% OFF",
      rating: 4.8,
      reviews: 189,
      image: "https://dynamic.tourtravelworld.com/package-images/photo-big/dir_12/332954/56448.jpg",
      badge: "Divine",
      badgeColor: "#FFD166",
      color: "#E76F51",
      icon: <GiIndiaGate />,
      itinerary: "Amritsar • Wagah Border",
      details: {
        title: "2 Nights / 3 Days – Golden Temple & Wagah Border",
        description: "Experience the divine serenity of Golden Temple and patriotic fervor at Wagah Border.",
        nightPlan: [
          { night: "Night 1-2", place: "Amritsar" }
        ],
        days: [
          {
            day: "Day 1",
            title: "Arrival & Golden Temple",
            activities: ["Arrival", "Golden Temple Visit", "Evening Aarti", "Hotel Check-in"]
          }
        ],
        inclusions: [
          { icon: <FaBed />, text: "2 Nights Hotel" },
          { icon: <FaUtensils />, text: "Daily Breakfast" },
          { icon: <FaCar />, text: "Local Transport" }
        ],
        exclusions: ["Air Tickets", "Personal Donations", "Shopping"],
        contact: {
          phone: "94157 99879",
          whatsapp: "9415799879",
          company: "Shree Balaji Travel"
        }
      }
    },
    {
      id: 4,
      title: "Mathura Vrindavan",
      subtitle: "Krishna Circuit",
      duration: "3N/4D",
      discount: "23% OFF",
      rating: 4.8,
      reviews: 167,
      image: "https://www.oyorooms.com/travel-guide/wp-content/uploads/2019/05/Mathura-Vrindavan-Spiritual-haven-for-devotees-Prem-Mandir-Image-3.jpg",
      badge: "Spiritual",
      badgeColor: "#9D4EDD",
      color: "#B5838D",
      icon: <GiTempleDoor />,
      itinerary: "Mathura • Vrindavan • Govardhan",
      details: {
        title: "3 Nights / 4 Days – Mathura Vrindavan Tour",
        description: "Divine journey through Krishna's birthplace and holy sites in Mathura and Vrindavan.",
        nightPlan: [
          { night: "Night 1-2", place: "Mathura" },
          { night: "Night 3", place: "Vrindavan" }
        ],
        days: [
          {
            day: "Day 1",
            title: "Arrival Mathura",
            activities: ["Arrival", "Krishna Janmasthan", "Evening Aarti", "Hotel Check-in"]
          }
        ],
        inclusions: [
          { icon: <FaBed />, text: "3 Nights Stay" },
          { icon: <FaUtensils />, text: "All Meals" },
          { icon: <FaCar />, text: "AC Transport" }
        ],
        exclusions: ["Special Puja", "Shopping", "Personal Expenses"],
        contact: {
          phone: "94157 99879",
          whatsapp: "9415799879",
          company: "Shree Balaji Travel"
        }
      }
    }
  ];

  const handleCardClick = (pkg) => {
    setSelectedPackage(pkg);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseDetails = () => {
    setSelectedPackage(null);
    document.body.style.overflow = 'auto';
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Thank you ${formData.name}! Your enquiry for ${selectedPackage.title} has been submitted. We'll contact you soon.`);
    setFormData({
      name: '',
      phone: '',
      email: '',
      date: '',
      message: ''
    });
  };

  return (
    <div className="pilgrimage-container">
      {/* Header */}
      <div className="pilgrimage-header">
        <h1>Sacred Pilgrimage Tours</h1>
        <p>Journey to divine destinations with spiritual guidance</p>
      </div>

      {/* 4 Cards Grid */}
      <div className="cards-grid-4">
        {packages.map((pkg) => (
          <div 
            key={pkg.id} 
            className="package-card"
            onClick={() => handleCardClick(pkg)}
          >
            <div className="card-image-section">
              <img src={pkg.image} alt={pkg.title} />
              <div className="image-overlay"></div>
              <div className="card-badge" style={{ background: pkg.badgeColor }}>
                {pkg.badge}
              </div>
              <div className="duration-tag">
                <FaClock /> {pkg.duration}
              </div>
            </div>

            <div className="card-content-section">
              <div className="card-header">
                <div className="package-icon" style={{ color: pkg.color }}>
                  {pkg.icon}
                </div>
                <div>
                  <h3>{pkg.title}</h3>
                  <p className="subtitle">{pkg.subtitle}</p>
                </div>
              </div>

              <div className="itinerary-line">
                <FaMapMarkerAlt />
                <span>{pkg.itinerary}</span>
              </div>

              <div className="rating-price">
                <div className="rating">
                  <FaStar style={{ color: '#FFD700' }} />
                  <span>{pkg.rating}</span>
                  <span className="reviews">({pkg.reviews} reviews)</span>
                </div>
                <div className="price-info">
                  <span className="price">{pkg.price}</span>
                  <span className="original-price">{pkg.originalPrice}</span>
                </div>
              </div>

              <div className="discount-tag" style={{ background: pkg.color }}>
                {pkg.discount}
              </div>

              <button className="view-details-btn">
                View Details →
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Package Details Modal */}
      {selectedPackage && (
        <div className="details-modal-overlay">
          <div className="details-modal">
            {/* Header with Close Button */}
            <div className="modal-header">
              <button className="back-btn" onClick={handleCloseDetails}>
                <FaArrowLeft /> Back to Packages
              </button>
              <button className="close-modal-btn" onClick={handleCloseDetails}>
                <FaTimes />
              </button>
            </div>

            <div className="modal-content">
              {/* Hero Section */}
              <div className="modal-hero">
                <img src={selectedPackage.image} alt={selectedPackage.title} />
                <div className="hero-content">
                  <h1>{selectedPackage.details.title}</h1>
                  <p className="hero-subtitle">{selectedPackage.details.description}</p>
                  <div className="hero-stats">
                    <div className="stat">
                      <FaClock />
                      <span>{selectedPackage.duration}</span>
                    </div>
                    <div className="stat">
                      <FaStar />
                      <span>{selectedPackage.rating} Rating</span>
                    </div>
                    <div className="stat price-stat">
                      <span className="current">{selectedPackage.price}</span>
                      <span className="original">{selectedPackage.originalPrice}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Night Stay Plan */}
              <div className="night-plan-section">
                <h2>
                  <FaBed className="section-icon" />
                  Night Stay Plan
                </h2>
                <div className="night-plan-grid">
                  {selectedPackage.details.nightPlan.map((night, index) => (
                    <div key={index} className="night-card">
                      <div className="night-number">{night.night}</div>
                      <div className="night-place">{night.place}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Detailed Itinerary */}
              <div className="itinerary-detailed-section">
                <h2>
                  <GiPrayerBeads className="section-icon" />
                  Detailed Itinerary
                </h2>
                <div className="timeline">
                  {selectedPackage.details.days.map((day, index) => (
                    <div key={index} className="timeline-item">
                      <div className="timeline-day">
                        <div className="day-icon">{day.icon || <FaSun />}</div>
                        <div className="day-number">{day.day}</div>
                      </div>
                      <div className="timeline-content">
                        <h3>{day.title}</h3>
                        <ul className="activities">
                          {day.activities.map((activity, i) => (
                            <li key={i}>
                              {activity.startsWith('  –') ? (
                                <span className="sub-activity">{activity}</span>
                              ) : activity.includes(':') ? (
                                <span className="heading-activity">{activity}</span>
                              ) : (
                                <><FaCheck className="check-icon" /> {activity}</>
                              )}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Inclusions & Exclusions */}
              <div className="includes-excludes-section">
                <div className="inclusions-box">
                  <h3>
                    <FaCheck className="check-icon" />
                    Inclusions
                  </h3>
                  <ul>
                    {selectedPackage.details.inclusions.map((item, index) => (
                      <li key={index}>
                        <span className="icon">{item.icon}</span>
                        {item.text}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="exclusions-box">
                  <h3>
                    <FaTimes className="times-icon" />
                    Exclusions
                  </h3>
                  <ul>
                    {selectedPackage.details.exclusions.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Booking Section */}
              <div className="booking-section">
                <div className="contact-info">
                  <h3>
                    <FaPhone className="section-icon" />
                    Book This Pilgrimage Tour
                  </h3>
                  <p>For best prices, hotel options and customised itinerary for your family or group, connect with our travel expert now.</p>
                  
                  <div className="contact-methods">
                    <a 
                      href={`tel:+91${selectedPackage.details.contact.phone}`}
                      className="contact-method call"
                    >
                      <FaPhone />
                      <div>
                        <span className="method-label">Call Now</span>
                        <span className="method-number">{selectedPackage.details.contact.phone}</span>
                      </div>
                    </a>
                    
                    <a 
                      href={`https://wa.me/91${selectedPackage.details.contact.whatsapp}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="contact-method whatsapp"
                    >
                      <FaWhatsapp />
                      <div>
                        <span className="method-label">WhatsApp Inquiry</span>
                        <span className="method-number">Instant Response</span>
                      </div>
                    </a>
                  </div>
                </div>

                {/* Enquiry Form */}
                <div className="enquiry-form-section">
                  <div className="enquiry-header">
                    <h4>Need Help?</h4>
                    <p className="contact-number">+91 {selectedPackage.details.contact.whatsapp}</p>
                    <p className="company-name">{selectedPackage.details.contact.company}</p>
                  </div>

                  <form className="enquiry-form" onSubmit={handleSubmit}>
                    <div className="form-row">
                      <div className="form-group">
                        <FaUser className="input-icon" />
                        <input
                          type="text"
                          name="name"
                          placeholder="Full Name"
                          value={formData.name}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <FaPhone className="input-icon" />
                        <input
                          type="tel"
                          name="phone"
                          placeholder="Mobile Number"
                          value={formData.phone}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <FaEnvelope className="input-icon" />
                        <input
                          type="email"
                          name="email"
                          placeholder="Email"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <FaCalendar className="input-icon" />
                        <input
                          type="date"
                          name="date"
                          value={formData.date}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <textarea
                        name="message"
                        placeholder="Enter Your Message"
                        value={formData.message}
                        onChange={handleInputChange}
                        rows="4"
                      ></textarea>
                    </div>

                    <button type="submit" className="submit-btn">
                      <FaPaperPlane /> Send Enquiry
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TourPackagesSection;